import { useGameStore } from '../store/gameStore'
import { Palette, Check } from 'lucide-react'

function BackgroundSelector() {
  const config = useGameStore((state) => state.config)
  const ownedBackgrounds = useGameStore((state) => state.ownedBackgrounds)
  const selectedBackground = useGameStore((state) => state.selectedBackground)
  const selectBackground = useGameStore((state) => state.selectBackground)

  if (!config) return null

  const backgrounds = config.shop?.cosmetics?.filter(item => item.type === 'background') || []

  return (
    <div className="bg-white rounded-xl shadow-lg p-6">
      <div className="flex items-center gap-2 mb-4">
        <Palette size={24} className="text-green-600" />
        <h3 className="text-xl font-bold">Arrière-plans</h3>
      </div>

      <div className="grid grid-cols-2 gap-3">
        {backgrounds.map((bg) => {
          const isOwned = ownedBackgrounds.includes(bg.id)
          const isSelected = selectedBackground === bg.id
          
          if (!isOwned) return null // Only show owned backgrounds

          return (
            <button
              key={bg.id}
              onClick={() => selectBackground(bg.id)}
              className={`relative rounded-lg overflow-hidden border-2 transition-all ${
                isSelected 
                  ? 'border-green-600 shadow-lg scale-105' 
                  : 'border-gray-300 hover:border-green-400'
              }`}
            >
              {/* Background preview */}
              <div 
                className="h-20 flex items-center justify-center text-xs font-bold text-white"
                style={{
                  background: `linear-gradient(to bottom, ${bg.gradient[0]}, ${bg.gradient[1]})`
                }}
              >
                {isSelected && (
                  <div className="absolute top-1 right-1 bg-green-600 rounded-full p-1">
                    <Check size={16} className="text-white" />
                  </div>
                )}
              </div>
              
              {/* Background name */}
              <div className="p-2 bg-gray-50 text-center">
                <p className="text-sm font-medium text-gray-800">{bg.name}</p>
              </div>
            </button>
          )
        })}
      </div>

      {ownedBackgrounds.length === 1 && (
        <p className="text-sm text-gray-500 mt-4 text-center">
          💡 Achetez plus d'arrière-plans dans la boutique !
        </p>
      )}
    </div>
  )
}

export default BackgroundSelector
